import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sf-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MathLevelYearTabs = _resolveComponent("MathLevelYearTabs")!
  const _component_DbMathLevels = _resolveComponent("DbMathLevels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MathLevelYearTabs, {
      modelValue: _ctx.defaultYear,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultYear) = $event)),
      class: "sf-year-tabs tw-mb-4"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_DbMathLevels, { "default-year": _ctx.defaultYear }, null, 8, ["default-year"])
  ]))
}